import React, { useState, useEffect, useRef } from "react";
import "./BillwiseReport.css";

export default function BillwiseReport({fromDate,toDate}) {

  const [partyList, setPartyList] = useState([]);
  const [itemList, setItemList] = useState([]);

  const [selectedParty, setSelectedParty] = useState("");
  const [selectedPartyId, setSelectedPartyId] = useState(null);

  const [selectedItem, setSelectedItem] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);



  const [showPartyPopup, setShowPartyPopup] = useState(false);
  const [showItemPopup, setShowItemPopup] = useState(false);

  const [partySearch, setPartySearch] = useState("");
  const [itemSearch, setItemSearch] = useState("");

  const [partyActiveIndex, setPartyActiveIndex] = useState(0);
  const [itemActiveIndex, setItemActiveIndex] = useState(0);
  const [reportData, setReportData] = useState([]);
const [grandTotal, setGrandTotal] = useState(0);
const [loading, setLoading] = useState(false);

  const popupRef = useRef(null);

  // ================= FETCH DATA =================
  useEffect(() => {
    fetch("/api/party")
      .then(res => res.json())
      .then(data => setPartyList(data))
      .catch(err => console.error(err));

    fetch("/api/items")
      .then(res => res.json())
      .then(data => setItemList(data))
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
  if (selectedPartyId && selectedItemId && fromDate && toDate) {
    fetchReport();
  }
}, [selectedPartyId, selectedItemId, fromDate, toDate]);

  // ================= FILTER =================
  const filteredParties = partyList
    .filter(p =>
      p.partyName?.toLowerCase().includes(partySearch.toLowerCase())
    )
    .sort((a, b) => a.partyName.localeCompare(b.partyName));

  const filteredItems = itemList
    .filter(i =>
      i.itemName?.toLowerCase().includes(itemSearch.toLowerCase())
    )
    .sort((a, b) => a.itemName.localeCompare(b.itemName));



// ✅ ADD HERE
const selectParty = (party) => {
  setSelectedParty(party.partyName);
  setSelectedPartyId(party.id);
  setShowPartyPopup(false);
};

const selectItem = (item) => {
  setSelectedItem(item.itemName);
  setSelectedItemId(item.id);
  setShowItemPopup(false);
};


  // ================= KEYBOARD NAVIGATION =================

useEffect(() => {
  if (selectedPartyId && selectedItemId && fromDate && toDate) {

    fetch(`/api/delivery/purchase-billwise?partyId=${selectedPartyId}&itemId=${selectedItemId}&from=${fromDate}&to=${toDate}`)
      .then(res => res.json())
      .then(data => {
        setReportData(data);

        const total = data.reduce(
          (sum, row) => sum + Number(row.totalAmount || 0),
          0
        );

        setGrandTotal(total);
      })
      .catch(err => console.error(err));
  }

}, [selectedPartyId, selectedItemId, fromDate, toDate]);

  useEffect(() => {
    const handleKey = (e) => {

      // PARTY POPUP
      if (showPartyPopup) {

        if (e.key === "ArrowDown") {
          setPartyActiveIndex(prev =>
            prev < filteredParties.length - 1 ? prev + 1 : prev
          );
        }

        if (e.key === "ArrowUp") {
          setPartyActiveIndex(prev =>
            prev > 0 ? prev - 1 : prev
          );
        }

        if (e.key === "Enter") {
          if (filteredParties[partyActiveIndex]) {
            const p = filteredParties[partyActiveIndex];
            setSelectedParty(p.partyName);
            setSelectedPartyId(p.id);
            setShowPartyPopup(false);
          }
        }

        if (e.key === "Escape") {
          setShowPartyPopup(false);
        }
      }

      // ITEM POPUP
      if (showItemPopup) {

        if (e.key === "ArrowDown") {
          setItemActiveIndex(prev =>
            prev < filteredItems.length - 1 ? prev + 1 : prev
          );
        }

        if (e.key === "ArrowUp") {
          setItemActiveIndex(prev =>
            prev > 0 ? prev - 1 : prev
          );
        }

        if (e.key === "Enter") {
          if (filteredItems[itemActiveIndex]) {
            const i = filteredItems[itemActiveIndex];
            setSelectedItem(i.itemName);
            setSelectedItemId(i.id);
            setShowItemPopup(false);
          }
        }

        if (e.key === "Escape") {
          setShowItemPopup(false);
        }
      }

    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);

  }, [
    showPartyPopup,
    showItemPopup,
    filteredParties,
    filteredItems,
    partyActiveIndex,
    itemActiveIndex
  ]);

  const fetchReport = async () => {
  try {
    setLoading(true);

    const res = await fetch(`/api/delivery/purchase-billwise?partyId=${selectedPartyId}&itemId=${selectedItemId}&from=${fromDate}&to=${toDate}`);

    const data = await res.json();
    setReportData(data);

    // Calculate Grand Total
    const total = data.reduce(
      (sum, row) => sum + (row.amount || 0),
      0
    );

    setGrandTotal(total);

  } catch (err) {
    console.error("Report fetch error:", err);
  } finally {
    setLoading(false);
  }
};
const handlePrint = () => {
  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
    <html>
    <head>
      <title>Purchase Billwise Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 20px;
        }

        .report-wrapper {
          border: 2px solid #000;
          padding: 10px;
        }

      .header-section {
  position: relative;
  margin: -10px -10px 15px -10px;   /* extend to wrapper border */
  border-bottom: 2px solid #000;
  padding: 10px 10px 10px 10px;
}

        .company-section {
          text-align: center;
        }

        .title {
          font-size: 20px;
          font-weight: bold;
        }

        .sub-title {
          margin-top: 4px;
          font-size: 14px;
        }

        .date-section {
          position: absolute;
          right: 0;
          top: 0;
          text-align: right;
          font-weight: bold;
          font-size: 14px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #000;
          padding: 6px;
          font-size: 14px;
          text-align: center;
        }

        th {
          background: #eaeaea;
        }

        td:first-child {
          text-align: center;
        }

        tfoot td {
          font-weight: bold;
        }

        /* Column widths similar balance */
        .col-dc { width: 12%; }
        .col-date { width: 18%; }
        .col-po { width: 15%; }
        .col-item { width: 25%; }
        .col-qty { width: 10%; }
        .col-amount { width: 20%; }

      </style>
    </head>

    <body>

      <div class="report-wrapper">

        <div class="header-section">

          <div class="company-section">
            <div class="title">ORANGE TRADINGS</div>
            <div class="sub-title">DHARAPURAM ROAD, TIRUPUR - 641 601</div>
          </div>

          <div class="date-section">
            <div>From Date : ${fromDate}</div>
            <div>To Date&nbsp;&nbsp;&nbsp;: ${toDate}</div>
          </div>

        </div>

        <table>
   <thead>
<tr>
<th className="col-inv">Inv No</th>
<th className="col-date">Date</th>
<th className="col-party">Party</th>
<th className="col-qty">Total Qty</th>
<th className="col-amt">Total Amount</th>
<th className="col-paid">Paid</th>
<th className="col-bal">Balance</th>
</tr>
</thead>

          <tbody>
            ${reportData.map(row => `
              <tr>
                <td>${row.dcNo}</td>
                <td>${row.deliveryDate}</td>
                <td>${row.poNo || ""}</td>
                <td>${row.itemName}</td>
                <td>${row.totalQty}</td>
                <td>${Number(row.totalAmount).toFixed(2)}</td>
              </tr>
            `).join("")}
          </tbody>

          <tfoot>
            <tr>
              <td colspan="5">Total</td>
              <td>${grandTotal.toFixed(2)}</td>
            </tr>
          </tfoot>

        </table>

      </div>

    </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.focus();
    printWindow.print();
    printWindow.close();  // auto close
  };
};



  // ================= UI =================
 return (
  <div className="billwise-container">

  {/* Table Section */}
<div className="billwise-table-section">

  {/* 🔹 FILTER BAR ABOVE TABLE (OUTSIDE TABLE) */}
  <div className="billwise-filter-bar">

    <div className="filter-field">
      <label>Party</label>
      <input
        type="text"
        value={selectedParty}
        readOnly
        placeholder="Click to select party"
        onClick={() => setShowPartyPopup(true)}
      />
    </div>

    <div className="filter-field">
      <label>Item</label>
      <input
        type="text"
        value={selectedItem}
        readOnly
        placeholder="Click to select item"
        onClick={() => setShowItemPopup(true)}
      />
    </div>

  </div>

  {/* 🔹 TABLE */}
  <div className="billwise-table-wrapper">
    <table className="billwise-table">
      <thead>
        <tr>
          <th>Dc No</th>
          <th>Date</th>
          <th>Po No</th>
          <th>Item</th>
          <th>Qty</th>
          <th>Amt</th>
        </tr>
      </thead>

   
         <tbody>
  {reportData.length > 0 ? (
    reportData.map((row, index) => (
      <tr key={index}>
        <td>{row.dcNo}</td>
        <td>{row.deliveryDate}</td>
        <td>{row.poNo}</td>
        <td>{row.itemName}</td>
        <td>{row.totalQty}</td>
        <td>{row.totalAmount}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="no-data">
        No data found
      </td>
    </tr>
  )}
</tbody>



        </table>
      </div>

    <div className="del-summary">

  <div className="del-summary-row">

    <div className="summary-field total">
      <label>Grand Total</label>
      <input value={grandTotal.toFixed(2)} readOnly />
    </div>

  </div>

</div>

    

  


      {/* BUTTONS CENTERED */}
      <div className="billwise-buttons">
        <button onClick={handlePrint}>Print</button>

        <button>Clear</button>
      </div>

    </div>

    {/* Party Popup */}
    {showPartyPopup && (
      <div className="popup-overlay">
        <div className="popup-box">
          <div className="popup-header">
            <span>Select Party</span>
            <button onClick={() => setShowPartyPopup(false)}>✕</button>
          </div>

          <input
            className="popup-search"
            autoFocus
            value={partySearch}
            onChange={(e) => setPartySearch(e.target.value)}
          />

          <div className="popup-list">
            {filteredParties.map((p) => (
              <div
                key={p.id}
                className="popup-row"
                onClick={() => selectParty(p)}
              >
                {p.partyName}
              </div>
            ))}
          </div>
        </div>
      </div>
    )}

    {/* Item Popup */}
    {showItemPopup && (
      <div className="popup-overlay">
        <div className="popup-box">
          <div className="popup-header">
            <span>Select Item</span>
            <button onClick={() => setShowItemPopup(false)}>✕</button>
          </div>

          <input
            className="popup-search"
            autoFocus
            value={itemSearch}
            onChange={(e) => setItemSearch(e.target.value)}
          />

          <div className="popup-list">
            {filteredItems.map((i) => (
              <div
                key={i.id}
                className="popup-row"
                onClick={() => selectItem(i)}
              >
                {i.itemName}
              </div>
            ))}
          </div>
        </div>
      </div>
    )}

  </div>
);
}